export const PREPROD_HOST = 'preprod.auto1.com'
